import {noop} from "./util/functions";
import {aPromise} from "./jqUtil";

interface ModallerCallback {
    (modaller: Modaller): any
}

export default class Modaller {
    private closeHandler: Function | null = null
    private modalOpts: any = {}

    content: JQuery

    constructor(content: any) {
        this.content = $(content);
        this.addHideListener(() => {
            this.content.remove();
        });
        this.addHideListener(() => {
            if (this.closeHandler) {
                this.closeHandler();
            }
        });
    }

    addShowListener(listener: ModallerCallback) {
        this.content.one('shown.bs.modal', () => {
            listener(this);
        });
    }

    addHideListener(listener: ModallerCallback) {
        this.content.one('hidden.bs.modal', () => {
            listener(this);
        });
    }

    show(callback?: ModallerCallback) {
        if (this.modalOpts.noHide) {
            this.modalOpts.backdrop = 'static';
            this.modalOpts.keyboard = false;
            this.content.find('.modal-header button[data-dismiss=modal]').remove()
        }

        this.content.one('shown.bs.modal', () => {
            if (typeof callback === "function") {
                callback(this);
            }
        });
        this.content.modal(this.modalOpts);
    }

    close() {
        this.content.modal('hide');
        this.content.remove();
    }

    setCloseHandler(handler: ModallerCallback) {
        this.closeHandler = handler;
    }

    addFooterLink(title: string, classes: string, href: string) {
        const footer = this.content.find('.modal-footer');

        $('<a class="' + classes + '"></a>')
            .attr('href', href)
            .text(title)
            .appendTo(footer);

        footer.show();
    }

    /**
     * @return button jquery instance
     * */
    addFooterButton(title: string, classes: string, handler: () => any): JQuery<HTMLElement> {
        const footer = this.content.find('.modal-footer');

        const button = $('<button class="' + classes + '"></button>')
            .text(title)
            .on('click', function () {
                handler();
                return false;
            })
            .appendTo(footer);

        footer.show();

        return button;
    }

    setTitle(title: string) {
        const header = this.content.find('.modal-header');
        header.find('.modal-title').text(title);
        header.show();
    }

    disableHide() {
        this.modalOpts.noHide = true;
    }

    centerFooterButtons() {
        this.content.find('.modal-footer').addClass('modal-footer-text-center');
    }

    center() {
        this.content.find('.modal-dialog').addClass('modal-dialog-centered');
    }

    addDialogClass(className: string) {
        this.content.find('.modal-dialog').addClass(className);
    }

    addBodyClass(className: string) {
        this.content.find('.modal-body').addClass(className);
    }

    handleUpdate() {
        this.content.modal('handleUpdate');
    }

    static showRemote(href: string, modallerCallback: ModallerCallback, failureCallback?: (error: any) => any) {
        if (!failureCallback) {
            failureCallback = noop;
        }

        return aPromise($.get(href))
            .then(
                html => {
                    return Modaller.showLocal(html, modallerCallback);
                },
                error => {
                    if (failureCallback) {
                        failureCallback(error);
                    }
                }
            );
    }

    static showLocal(body: string, modallerCallback: ModallerCallback): Promise<any> {
        if (!modallerCallback) {
            modallerCallback = noop;
        }

        const template = `
<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" style="display: none;">
        <h5 class="modal-title"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" class="far fa-times-circle"></span>
        </button>
      </div>
      <div class="modal-body">${body}</div>
      <div class="modal-footer modal-footer-modaller" style="display: none;"></div>
    </div>
  </div>
</div>
        `;

        return new Promise((resolve, reject) => {
            const modaller = new Modaller(template);
            modallerCallback(modaller);
            modaller.show();
            modaller.addHideListener(() => {
                resolve(modaller);
            })
        });
    }

    static showForbidden(l18n: { get: any }, titleKey: string, noticeKey: string) {
        var buttonPre = 'packPage.dialogs.forbidden.alert';

        const template = `
    <p class="text-center">${l18n.get(noticeKey)}</p>
    <p class="text-center"><span style="margin-right: 1em;">${l18n.get(buttonPre)}</span><a href="/login" class="btn btn-primary">${l18n.get('packPage.dialogs.login')}</a></p>
`;

        Modaller.showLocal(template, modaller => {
            modaller.setTitle(l18n.get(titleKey));
        });
    }

    static showPrompt(options: any): Promise<any> {
        const html = `
<div class="modal-prompt">
    <p class="modal-prompt__text">${options.text}</p>
    <div class="modal-prompt__buttons text-center">
        <button class="btn btn-sm btn-primary" type="button" data-click="ok">${options.ok}</button>    
        <button class="btn btn-sm btn-light" type="button" data-click="cancel">${options.cancel}</button>    
    </div>
</div>        
`;

        let ok = false;
        return Modaller.showLocal(html, modaller => {

            if (options.element) {
                modaller.content.addClass('modal-popover');
                modaller.content.one('shown.bs.modal', () => {
                    const windowWidth = $(window).outerWidth();
                    const windowHeight = $(window).outerHeight();
                    if (windowWidth && windowHeight) {
                        const viewPosition = options.element.getBoundingClientRect();
                        const modalCss = {
                            position: 'fixed',
                            right: windowWidth - viewPosition.right,
                            bottom: windowHeight - viewPosition.top
                        }
                        modaller.content.find('.modal-dialog').css(modalCss);
                    }
                });
            } else {
                modaller.center();
            }


            modaller.content.find('.modal-prompt__buttons button[data-click=ok]').click(e => {
                ok = true;
                modaller.close();
            });

            modaller.content.find('.modal-prompt__buttons button[data-click=cancel]').click(e => {
                modaller.close();
            });
        })
            .then(modaller => {
                return new Promise((resolve, reject) => {
                    (ok ? resolve : reject)(modaller);
                });
            }, noop);
    }
}